import React, { Component } from 'react';
import {Button, Collapse, Alert} from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import { debounce } from 'lodash';

import Logic from '../../Logic';

import CandidatesTable from '../../Components/CandidatesTable/CandidatesTable';
import CreateCandidateModal from '../../Components/CreateCandidateModal/CreateCandidateModal';
import Pager from '../../Components/Pager/Pager';

class MyCandidates extends Component {

    constructor(props) {
        super(props);
        this.state = {
            PAGESIZE: this.props.init.user.candidates.pageSizes[0], 
            candidates: this.props.init.user.candidates == null ? [] : this.props.init.user.candidates, 
            isFilesUploadOpen:false, 
            query:'', 
            showCreateCandidateModal:false,
        };

        this.logic = new Logic(this.props.init);
        this.getPage = this.getPage.bind(this);
        this.onQueryChanged = this.onQueryChanged.bind(this);
        this.throttleGetPage = debounce(this.throttleGetPage.bind(this), 250);
        this.pageSizeChanged = this.pageSizeChanged.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
        this.toggleCreateCandidateModal = this.toggleCreateCandidateModal.bind(this);
        this.createNew = this.createNew.bind(this);
        this.cancel = this.cancel.bind(this);
        this.extend = this.extend.bind(this);
        this.confirmCandidate = this.confirmCandidate.bind(this);
        this.reInvite = this.reInvite.bind(this);
    }

    componentDidMount(){
        let isToRefresh = this.props.location.state ? this.props.location.state.isToRefresh : false;
        if(isToRefresh){
            window.location.reload();
        }
    }

    toggleCreateCandidateModal(){
        this.setState({showCreateCandidateModal : !this.state.showCreateCandidateModal});
    }

    createNew(){
        this.toggleCreateCandidateModal();
    }


    onQueryChanged(evt) {
        let edata = {id:evt.id, value: evt.target.value};
        this.setState({query:evt.target.value});
        this.throttleGetPage(edata);
    }

    throttleGetPage(edata){
        this.getPage(1, this.state.PAGESIZE, edata.value);
    }

    getPage(pageNumber,pageSize,query){
        if(this.state.candidates.currentPage != pageNumber || pageSize && this.state.PAGESIZE != pageSize || query && query.length > 2){ //get page from server
            
            this.logic.getTablePage('User/GetCandidates', pageNumber, pageSize, query, (data) => {
                this.setState({ 
                    candidates:{
                        currentPage: data.currentPage, 
                        totalPages: data.totalPages,
                        totalRows: data.totalRows,
                        rows: data.rows,
                    },
                    PAGESIZE: pageSize,
                    // query: query // it cause bumps when searching in autocomplete
                });
            }
        )
        }else{
            this.setState({
                candidates:{
                    currentPage: this.props.init.user.candidates.currentPage, 
                    totalPages: this.props.init.user.candidates.totalPages,
                    totalRows: this.props.init.user.candidates.totalRows,
                    rows: this.props.init.user.candidates.rows,
                },
                PAGESIZE: this.state.PAGESIZE,
                // query: query // it cause bumps when searching in autocomplete
            });
        }
    }

    pageSizeChanged(pageSize){
        this.getPage(1, pageSize, this.state.query);
    }

    pageChanged(pageNumber){
        this.getPage(pageNumber, this.state.PAGESIZE, this.state.query);
    }

    cancel(candidate, buttonDisabler){
        if(window.confirm('האם אתה בטוח שברצונך למחוק את בקשת בדיקת המהימנות ל ' + candidate.firstName + ' ' + candidate.lastName + ' - ' + candidate.identityNumber + ' ?')){
            let toggleSpinner = this.props.toggleSpinner;
            let logic = new Logic();
            toggleSpinner();
            buttonDisabler(true);
            logic.cancelCandidate(candidate, (res) => {
                window.alert(res.message);
                buttonDisabler(false);
                this.props.onInitChanged(res.data);
                toggleSpinner();
            });
        }
    }

    extend(candidate, buttonDisabler){
        if(window.confirm('האם אתה בטוח שברצונך להאריך את בקשת בדיקת המהימנות ל ' + candidate.firstName + ' ' + candidate.lastName + ' - ' + candidate.identityNumber + ' ?')){
            let toggleSpinner = this.props.toggleSpinner;
            // let logic = new Logic();
            buttonDisabler(true);
            this.logic.extendCandidate(candidate, (res) =>{
                window.alert(res.message);
                buttonDisabler(false);
                this.props.onInitChanged(res.data);
                toggleSpinner();
            });
        }
    }

    reInvite(candidate, buttonDisabler){
        if(window.confirm('האם אתה בטוח שברצונך לשלוח מסרון ומייל פעם נוספת ל ' + candidate.firstName + ' ' + candidate.lastName + ' - ' + candidate.identityNumber + ' ?')){
            let toggleSpinner = this.props.toggleSpinner;
            let logic = new Logic();
            buttonDisabler(true);
            logic.reInviteCandidate(candidate, (res) =>{
                window.alert(res.message);
                buttonDisabler(false);
                this.props.onInitChanged(res.data);
                toggleSpinner();
            });
        }
    }

    confirmCandidate(candidate, buttonDisabler){
        if(window.confirm('האם בדקת שלא חסרים פרטים?')){
            let toggleSpinner = this.props.toggleSpinner;
            let logic = new Logic();
            buttonDisabler(true);
            logic.confirmCandidate(candidate, (res) =>{
                window.alert(res.message);
                buttonDisabler(false);
                this.props.onInitChanged(res.data);
                toggleSpinner();
            });
        }
    }

    render(){
        let haveRows = this.state.candidates && this.state.candidates.totalRows > 0;
        return (
            <div className="col-xs-12">
                <div>
                    <div style={{padding:'1rem'}}>
                        <h1>רשימת מועמדים</h1>
                        <div style={{marginTop:'1rem', marginBottom:'1rem'}}>
                            <Button color="primary" style={{margin:'0rem 0rem 1rem 0', float:'right'}} onClick={this.createNew} className="col-sm-4 col-md-1 d-block d-md-none"><FontAwesome name="user-plus"/> צור מועמד חדש</Button>
                            <Button color="primary" style={{margin:'0rem 0rem 1rem 0', float:'left'}} onClick={this.createNew} className="col-sm-4 col-md-1 d-none d-md-block"><FontAwesome name="user-plus"/> צור מועמד חדש</Button>
                            {haveRows || this.query != '' ?
                            <>
                                <input type="text" style={{border:'1px solid #EAEDF8', borderRadius:'40px', position:'initial', outline:'0', padding:'8px 20px 8px 8px'}} className="col-sm-12 col-md-3 float-right" id="txtFilter" placeholder="סינון לפי שם, מייל, תז או טלפון" value={this.state.query} onChange={this.onQueryChanged} />
                                <FontAwesome name="search" style={{marginRight:'-30px', marginTop:'15px'}} className="float-right"/>
                            </> : null }
                            <div style={{clear:'both'}}></div>
                        </div>
                    </div>
                        
                    {haveRows ?
                    <div>
                        <CandidatesTable {...this.props} data={this.state.candidates.rows} onCancelClicked={this.cancel} onExtendClicked={this.extend} onReInviteClicked={this.reInvite} onEditClicked={this.edit} onConfirmClicked={this.confirmCandidate} onFilterChanged={this.onFilterChanged}/>
                        <Pager totalRows={this.state.candidates.totalRows} pageSizes={this.props.init.user.candidates.pageSizes} onPageChanged={this.pageChanged} onPageSizeChanged={this.pageSizeChanged} currentPage={this.state.candidates.currentPage} totalPages={this.state.candidates.totalPages} pageSize={this.state.PAGESIZE}/>
                    </div> : null}
                </div>
                
                <CreateCandidateModal {...this.props} isOpen={this.state.showCreateCandidateModal} toggle={this.toggleCreateCandidateModal} />

                {this.state.candidates.totalRows < 1 ?
                    <div>
                        {this.state.query ?
                        <Alert color="info" className="col-md-3 mx-auto">לא נמצאו מועמדים העומדים בתנאי הסינון. ¯/_(ツ)_\¯</Alert> :
                        <Alert color="info" className="col-md-3 mx-auto">לא נמצאו מועמדים המשתייכים למשתמש המחובר. ¯/_(ツ)_\¯</Alert>
                        }
                    </div> 
                : null }
            </div>
        );
    }
};

export default MyCandidates;